var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap',_vm._g(_vm._b({on:{"refreshBlock":_vm.refresh}},'wrap',_vm.$props,false),_vm.$listeners),[(_vm.src)?_c('iframe',{ref:"iframe",staticClass:"h-100 w-100 border-0",attrs:{"src":_vm._f("checkValidURL")(_vm.src)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }